import { objectValues } from '@webmozarts/object-has-own';

export enum Unit {
    AMOUNT = 'amount',
    AREA = 'area',
    BOOLEAN = 'boolean',
    ENERGY = 'energy',
    LITERS = 'liters',
    MILLIMETER = 'millimeter',
    PERCENT = 'percent',
    VOLUME = 'volume',
    WEIGHT = 'weight',
    NOTE = 'note',
}

export const ALL_UNITS: Unit[] = objectValues(Unit);

const UNIT_SUFFIX: Record<Unit, string> = {
    [Unit.AMOUNT]: ' x',
    [Unit.AREA]: ' ha',
    [Unit.BOOLEAN]: '',
    [Unit.ENERGY]: ' kWh',
    [Unit.LITERS]: ' l',
    [Unit.MILLIMETER]: ' mm',
    [Unit.PERCENT]: '%',
    [Unit.VOLUME]: ' m³',
    [Unit.WEIGHT]: ' kg',
    [Unit.NOTE]: '',
};

const PLACEHOLDER_BY_UNIT: Record<Unit, string> = {
    [Unit.AMOUNT]: $localize`:@@unit.placeholder.amount:Anzahl`,
    [Unit.AREA]: $localize`:@@unit.placeholder.area:in Hektar (ha)`,
    [Unit.BOOLEAN]: '',
    [Unit.ENERGY]: $localize`:@@unit.placeholder.energy:in Kilowattstunden (kWh)`,
    [Unit.LITERS]: $localize`:@@unit.placeholder.liters:in Liter (l)`,
    [Unit.MILLIMETER]: $localize`:@@unit.placeholder.millimeter:in Millimeter (mm)`,
    [Unit.PERCENT]: $localize`:@@unit.placeholder.percent:in Prozent (%)`,
    [Unit.VOLUME]: $localize`:@@unit.placeholder.volume:in Kubikmeter (m³)`,
    [Unit.WEIGHT]: $localize`:@@unit.placeholder.weight:in Kilogramm (kg)`,
    [Unit.NOTE]: '',
};

export function isUnit(unit: any): unit is Unit {
    return Object.values(Unit).includes(unit);
}

export function getMaskByUnit(unit: Unit | null): string {
    if (null === unit) {
        return 'A*';
    }

    return mapPrecisionToMask(mapUnitToPrecision(unit));
}

export function mapPrecisionToMask(precision: number): string {
    return `separator.${precision}`;
}

export function getSuffixByUnit(unit: Unit | null): string {
    if (null === unit) {
        return '';
    }

    return UNIT_SUFFIX[unit];
}

export function getPlaceholderByUnit(unit: Unit | null): string {
    if (null === unit) {
        return '';
    }

    return PLACEHOLDER_BY_UNIT[unit];
}

export function mapUnitToPrecision(unit: Unit): number {
    switch (unit) {
        case Unit.AREA:
        case Unit.LITERS:
            return 2;

        case Unit.AMOUNT:
            return 1;

        default:
            return 0;
    }
}
